import React from 'react';
const Commission32 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "12",
        height: "12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M7.638 4.808l-.822-.765C6.01 2.606 7.786.697 10.38 1.44c.138.04.166.22.05.304-.245.18-.535.543-.57 1.253-.07 1.427-1.062 2.5-2.221 1.811zM6.909 5.197c.438.44.456 1.397.042 1.81-1.438 1.132-4.738 3.726-4.735 3.725h-.003c-.17.083-.441 0-.651-.21-.2-.2-.284-.454-.222-.626 0 0 2.814-3.563 3.76-4.75.414-.413 1.37-.39 1.809.05z"
    }));
Commission32.displayName = 'Commission32';
export default Commission32;
